<template>
	<div class="bet-index">
		<div class="bet-index-container">
			<div class="title">
				<span :style='{ 
					color : "#fff",
					background: colors.theme == "dark" ? colors[colors.theme].to : "#000"
				}'>{{ $t("components.betOption.title") }}</span>
			</div>
			<div class="subtitle">
				<span :style='{ color : colors.theme == "dark" ? "#fff" : "#000"}'>{{ $t("components.betOption.subtitle") }}</span>
				<span class="shadow" :style='{ color : colors.theme == "dark" ? "#fff" : "#000"}'>{{ $t("components.betOption.subtitle") }}</span>
			</div>
		</div>
	</div>
</template>
<script>

export default {
  props: {
    index: {
      type: Number,
    },
  },
  data() {
    return {
      colors: {},
    };
  },
  created() {
    this.colors = JSON.parse(localStorage.getItem("colors"));
  },
};
</script>
<style lang="scss">
.bet-index {
	// height: 30%;
	// display: flex;
	// align-items: flex-end;
	// justify-content: center;

	.bet-index-container {
		// height: 75%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-evenly;

		.title{
			padding: 2rem 0 1rem;
			span{
				border-radius: 40px;
				padding: 3px 25px;
				text-transform: uppercase;
				font-weight: 700;
				letter-spacing: 4px;			
			}
		}
		.subtitle{
			display: flex;
			flex-direction: column;
			height: inherit;


			.shadow{
				-webkit-text-fill-color: transparent;
				-webkit-text-stroke-width: 1px;
				// -webkit-text-stroke-color: white;
				position: relative;
				top: -67px;
				left: 3px;
			}
			span{
				font-size: 70px;
				font-weight: 900;
				text-transform: uppercase;
				letter-spacing: 0px;			
				// text-shadow: 2px 2px 0px rgba(250, 250, 250, 1);			
			}
		}
	}
}

@media only screen and (min-height: 650px) {
  .bet-index {
	display: flex;
	justify-content: center;
	align-items: flex-end;
    .bet-index-container {
    //   height: 75%;

      .enigma-puzzle-index svg {
        height: 180px;
      }
    }
  }
}

@media only screen and (min-height: 750px) {
  .bet-index {
	
    .bet-index-container {
    //   height: 55%;

      .bet-index-circle {
        width: 190px;
        height: 190px;

        .bet-index-image {
          height: 92%;
        }
      }

      .bet-index-step {
        .index-step {
          font-size: 15px;
        }
      }
    }
  }
}
</style>
